import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import CheckIcon from '@offerzen/zenicon/CheckIcon'
import { colors } from '../../../themes'
import styles, { itemTheme, iconTheme } from './styles'
import AccessibleIcon from '../../AccessibleIcon'
import SmallText from '../../../typography/SmallText'

const SingleOption = ({ theme, label, subLabel, selected, focused, className, ...props }) => (
  <li
    role="option"
    aria-selected={selected}
    className={cx(styles.item, itemTheme(theme, selected, focused), className)}
    tabIndex={props.disabled ? '-1' : '0'}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}>
    {label}
    {Boolean(subLabel) && <SmallText className={styles.subItem}>{subLabel}</SmallText>}
    {Boolean(selected) && (
      <div className={styles.icon}>
        <AccessibleIcon icon={CheckIcon} color={props.disabled ? colors.geyser : iconTheme(theme)} size={16} />
      </div>
    )}
  </li>
)

SingleOption.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string.isRequired,
  subLabel: PropTypes.string,
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  focused: PropTypes.string,
  theme: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
}

export default SingleOption
